import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AppointmentBehaviour, MembershipBehaviour } from '@fitness-force/enum';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'membership-behaviour-view',
  templateUrl: './membership-behaviour.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class MembershipBehaviourComponent implements OnInit {
  behavior: any;
  activeBehavior: any;
  columnData: BehaviorSubject<any> = new BehaviorSubject(null);
  additionData: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor() {}

  ngOnInit(): void {
    this.columnData.subscribe({
      next: (cData: any) => {
        for (let [key, value] of Object.entries(MembershipBehaviour)) {
          if (key == cData?.behaviour) {
            this.activeBehavior = { name: value, key };
          }
        }
      },
    });
  }
}
